export interface DocumentThemeQuoteHeaderOptions {

    /* Show Contact - displays the contact from the parent entity(e.g.opportunity contact) */
    showContact: boolean;

    /* Show Site - displays the site from the parent entity (e.g. opportunity site) */
    showSite: boolean;

    /* Show Description - displays the quote description */
    showDescription: boolean;

    /* Show Terms & Conditions - displays the terms & conditions section and the relevant text */
    showTerms: boolean;

    /* Show Owner Details - displays the owner, contact number and email address of the parent contact(e.g.opportunity owner) */
    showOwnerDetails: boolean;

    /* Allows overwriting the name quote useful for creating Estimates etc */
    entityName: string;

    showCustomerReference: boolean;

    showPO: boolean;
}

export interface DocumentThemeQuoteSectionOptions {

    /* 
    Show Sections
    -- if false, all options below these are also set to false and are not editable.If this is false, we only send across a single line with the total of the entire quote.There will be no lines, it will just be the footer totals(e.g.sub total, tax, total)
    -- if true, sections are sent across as a table, with their name as their description, in the order that they are in the quote.
    */
    show: boolean;

    /*
    Show Section Totals
    -- if on, display a section sub - total after each section, incl.a tax value for the section and an amount ex - tax
    */
    showTotals: boolean;

    /* 
    Show Section Items
    -- if on, the items under a section will be visible under each section
    -- if false, the items under a section will not be displayed and a single item will be sent across with the section
    */
    showItems: boolean;

    /* 
    Show Section Description
    -- if on, the description under a section will be visible under each section
    -- if false, the description under a section will not be displayed.
    */
    showDescription: boolean;
}

export interface DocumentThemeQuoteItemOptions {

    /* 
    Show Quantity - if false, no quantity will be displayed
     */
    showQuantity: boolean;

    /* 
    Show Unit Price - if false, no unit price will be displayed 
    */
    showUnitPrice: boolean;

    /* 
    Show Adjustments - if false, no adjustments will be displayed.the adjustment will either be the percentage or dollar value
    */
    showAdjustments: boolean;

    /*
    Show Total - if false, no line total will be displayed.If true, display the tax amount of the line and the total ex tax
    */
    showTotals: boolean;

    showLongDescription: boolean;

}

export interface DocumentThemeQuoteOptions {

    header: DocumentThemeQuoteHeaderOptions;
    sections: DocumentThemeQuoteSectionOptions;
    items: DocumentThemeQuoteItemOptions;
}

export const defaultQuoteOptions = {
    header: {
        entityName: 'Quote',
        showContact: true,
        showSite: true,
        showDescription: true,
        showTerms: true,
        showOwnerDetails: true,
        showCustomerReference: true,
        showPO: true
    },
    sections: {
        show: true,
        showTotals: true,
        showItems: true,
        showDescription: false,
    },
    items: {
        showQuantity: true,
        showUnitPrice: true,
        showAdjustments: true,
        showTotals: true,
        showLongDescription: false
    }
} as DocumentThemeQuoteOptions;